// Shared status-to-step mapping logic used by ReferralStatusStepper and StatusProgressDots.
// The 4-step progression: Received (0) -> Contacting (1) -> Scheduled (2) -> Seen (3)
// Terminal statuses (declined, canceled, etc.) map to -1.

const STATUS_TO_STEP = {
  Received: 0,
  'Under Review': 1,
  Accepted: 1,
  Contacted: 1,
  'Contacting Patient': 1,
  'Waiting on Info': 1,
  'Appointment Scheduled': 2,
  Scheduled: 2,
  Completed: 3,
  Seen: 3,
  'Seen/Visit Held': 3,
  'Unable to Reach Patient': -1,
  'Patient Declined': -1,
  Returned: -1,
  'Canceled/Declined': -1,
  Cancelled: -1,
  Canceled: -1,
};

const TERMINAL_KEYWORDS = ['declined', 'canceled', 'cancelled', 'unable', 'returned'];

export const getStatusIndex = (status) => {
  if (!status) return 0;

  // Check exact match first
  if (STATUS_TO_STEP[status] !== undefined) {
    return STATUS_TO_STEP[status];
  }

  // Check partial match (case-insensitive)
  const normalized = status.toLowerCase();
  if (normalized.includes('received')) return 0;
  if (normalized.includes('contacting')
    || normalized.includes('waiting')
    || normalized.includes('info')
    || normalized.includes('review')
    || normalized.includes('accepted')
    || normalized.includes('contacted')) return 1;
  if (normalized.includes('scheduled')) return 2;
  if (normalized.includes('seen')
    || normalized.includes('visit')
    || normalized.includes('held')
    || normalized.includes('completed')) return 3;

  if (TERMINAL_KEYWORDS.some((keyword) => normalized.includes(keyword))) {
    return -1;
  }

  return 0; // default to first step
};
